import { useNavigate } from "react-router-dom";

const MenuCard = ({ icon, name, path }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/${path}`);
  };

  return (
    <div
      onClick={handleClick}
      className="
 flex flex-col items-center text-center
cursor-pointer
mb-3 xl:mb-3
group
transform-gpu
transition-transform duration-300 ease-out
hover:scale-110
      "
    >
      {/* ICON */}
      <div
        className="
          w-14 h-14
          flex items-center justify-center
          rounded-xl
          transition
        "
      >
        <img
          src={icon}
          alt={name}
          className="w-12 h-12 object-contain"
        />
      </div>

      {/* TITLE */}
      <div
        className="
          mt-1
          text-base
          font-medium
          text-slate-800 dark:text-slate-300
          transition
        "
      >
        {name}
      </div>
    </div>
  );
};

export default MenuCard;